// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ccwBB","main-image":"Header_main-image__7P2Cm"};